import React from "@bestowinc/tinkertoy-shell-deps/react";
import type { ReactNode } from "@bestowinc/tinkertoy-shell-deps/react";

type RenderFallbackBoundaryProps = {
  fallback: ReactNode;
  onError?: (error: unknown) => void;
  children: ReactNode;
};

/**
 * Renders `fallback` instead of a subtree that throws, so loading UI never
 * escalates to the route's error boundary. Key it by what it wraps to reset it.
 */
export class RenderFallbackBoundary extends React.Component<
  RenderFallbackBoundaryProps,
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: unknown): void {
    this.props.onError?.(error);
  }

  override render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
